import { Button } from '@material-tailwind/react';
import * as XLSX from 'xlsx';
import Axios from 'axios';

const ExportToExcelEventoInscriptos = ({ fileName,id_evento }) => {

  return (
    <Button variant="gradient" className="flex ml-2 items-center gap-3" onClick={(e)=>exportToExcel(fileName,id_evento)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-4 w-4/"
            >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
        </svg>
      Exportar Excel
    </Button>
  );
};

export default ExportToExcelEventoInscriptos;

  export const exportToExcel = async (fileName,id_evento) => {
    let dataExcel = [];

    const data = await buscarInscriptos(id_evento);

    data.map(item => {
      let newData =
          // {
          // Nombre: item.nombre,
          // DNI: item.nro_documento,
          // Provincia: item.provincia,
          // Edad: item.edad,
          // Email: item.email,
          // Sexo: item.sexo,
          // Estado: item.cod_interno,
          // idMP: item.mp_id,
          // ["Código web"]: item.codigo_web,
          // ["Fecha inscripción"]: item.f_alta,
          // Cobrador:item.cobrador,
          // Presente: item.presente ? 'SI': 'NO',
          // ["Fecha ingreso"]: item.f_ingreso,
          // ["Hora ingreso"]: item.h_ingreso,
          // ["Usuario ingresa"]: item.usuario_ingreso,
          // ["Tipo inscripción"]: item.detalle,
          // Matrimonial: item.tarif_matr ? 'SI': 'NO',
          // Importe: item.importe,
          // Categoria: item.categoria,
          // Region: item.region,
          // Rango: item.rango
          // }
          {
            Nombre: item.nombre,
            DNI: item.nro_documento,
            Provincia: item.provincia,
            Edad: item.edad,
            Sexo: item.sexo,
            ["Cat."]: item.categoria,
            ["Región"]: item.region,
            Rango: item.rango,
            Email: item.email,
            ["Tipo inscripción"]: item.detalle,
            ["Fecha inscripción"]: item.f_alta,
            Cobrador:item.cobrador,
            Importe: item.importe,
            idMP: item.mp_id,
            ["Código web"]: item.codigo_web,
            Presente: item.presente ? 'SI': 'NO',
            ["Fecha ingreso"]: item.f_ingreso,
            ["Hora ingreso"]: item.h_ingreso,
            ["Usuario ingresa"]: item.usuario_ingreso,
             Matrimonial: item.tarif_matr ? 'SI': 'NO',
            Estado: item.cod_interno,
            }       
      dataExcel.push(newData);
   })
    // Crear la hoja de cálculo desde un arreglo de datos
    const worksheet = XLSX.utils.json_to_sheet(dataExcel, { origin: 'A1' }); 
    
    // Ancho de columnas
    worksheet['!cols'] = [
      { wch: 30 },        // nombre
      { wch: 10 },        // dni
      { wch: 12, },       // provincia
      { wch: 5 },         // edad
      { wch: 5 },        // sexo
      { wch: 5 },         // categoria
      { wch: 5 },        // region
      { wch: 5 },        // rango
      { wch: 30 },        // email
      { wch: 30 },        // tipo inscr
      { wch: 15 },        // fecha inscr
      { wch: 15 },        // cobrador
      { wch: 10 },        // importe
      { wch: 10 },         // mp_id
      { wch: 10 },        // codigo web
      { wch: 5 },         // presente?
      { wch: 10 },        // fecha ingreso
      { wch: 10 },        // hora ingreso
      { wch: 15 },        // usuario ingresa
      { wch: 5 },        // matrimonial?
      { wch: 10 }         // estado
      // Añade más columnas si es necesario
    ];

    // Crear un nuevo libro de trabajo
    const workbook = XLSX.utils.book_new();

    // Añadir la hoja al libro
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Descargar el archivo
    XLSX.writeFile(workbook, `${fileName}-${id_evento}.xlsx`);
  };

const buscarInscriptos = async (id_evento)=>{
    try{
        const {data} = await Axios.get(`/api/tablasgenerales/eventos/inscriptos/${id_evento}`)
        return data.inscriptos
    }catch(err){
        console.log('Error al buscar los presentes en la asamblea en exportación a excel',err)
        return []
    }
}